import { render, staticRenderFns } from "./followupRecord.vue?vue&type=template&id=4f935128&scoped=true"
import script from "./followupRecord.vue?vue&type=script&lang=js"
export * from "./followupRecord.vue?vue&type=script&lang=js"
import style0 from "./followupRecord.vue?vue&type=style&index=0&id=4f935128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f935128",
  null
  
)

export default component.exports